import { useTimeDifference } from "hooks/useTimeDifference";
import React from "react";
import { appStore } from "store";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { shadowAndBorderClass } from "screens/Dashboard/utils/classes";

interface CountdownProps {
  targetDate: string;
}

interface DateTimeDisplayProps {
  label: string;
  value: number;
}

const DateTimeDisplay = ({ value, label }: DateTimeDisplayProps) => {
  const { t } = useTranslation();
  return (
    <div className="relative flex flex-col items-center justify-center gap-[4px] max-lg:gap-[4px] p-[8px] max-lg:p-[8px] flex-1 bg-[#252525] rounded-[8px] max-lg:rounded-[6px] border border-white/[0.06]">
      <div className="w-fit font-luxora-regular mt-[-1px] max-lg:mt-[-1px] opacity-40 text-white text-[12px] max-lg:text-[12px] text-center tracking-[0] leading-[14px] max-lg:leading-[14px] whitespace-nowrap">
        {t(label)}
      </div>
      <div className="w-fit font-luxora-medium text-white text-[24px] max-lg:text-[24px] tracking-[0] leading-[normal]">
        {value.toString().padStart(2, "0")}
      </div>
    </div>
  );
};

export const CountdownTimer: React.FC<CountdownProps> = ({ targetDate }) => {
  const { isLoading } = appStore();
  const { t } = useTranslation();

  const { days, hours, minutes, seconds } = useTimeDifference(
    new Date(targetDate).getTime(),
    !isLoading,
  );

  return (
    <div className={clsx(
      "relative flex flex-col items-start gap-[8px] max-lg:gap-[8px] p-[8px] max-lg:p-[8px] w-full rounded-[16px] max-lg:rounded-[16px] before:!rounded-[16px] max-lg:before:!rounded-[16px] bg-[#161616]",
      shadowAndBorderClass
    )}>
      <div className="flex items-center justify-center gap-[10px] max-lg:gap-[10px] px-[4px] max-lg:px-[4px] py-0 w-full">
        <div className="flex-1 mt-[-1px] font-luxora-regular max-lg:mt-[-1px] text-white/40 text-[16px] max-lg:text-[14px] tracking-[0] leading-[18px] max-lg:leading-[18px]">
          {t("round1TimeLeft")}
        </div>
      </div>
      <div className="flex items-center gap-[8px] max-lg:gap-[8px] w-full">
        <DateTimeDisplay value={days} label="Days" />
        <DateTimeDisplay value={hours} label="Hours" />
        <DateTimeDisplay value={+minutes} label="Minutes" />
        <DateTimeDisplay value={+seconds} label="Seconds" />
      </div>
    </div>
  );
};
